// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .circle-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.5rem 0;
  }
  
  .circle-image {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 50%; /* ✅ makes it a circle */
    border: 3px solid #444;
  }
  
  .item-title {
    margin-top: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
  }
  
  .circle-image-cat {
    width: 200px;
    height: 200px;
    object-fit: cover;
    border-radius: 50%; /* ✅ makes it a circle */
    border: 3px solid #444;
    margin: auto;
  }
  @media screen and (min-width: 850px) and (max-width: 850px) {
    .circle-image-cat {
      width: 150px;
      height: 150px;
      object-fit: cover;
      border-radius: 50%; /* ✅ makes it a circle */
      border: 3px solid #444;
      margin: auto;
    }
  }
 


  .scroll-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .scroll-content {
    width: 100%;
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    scroll-behavior: smooth;
    padding: 1rem;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .scroll-content::-webkit-scrollbar {
    display: none;
  }
  
  .scroll-item {
    min-width: 250px;
    background: #eee;
    padding: 1rem;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .scroll-item1 {
    min-width: 250px;
    background: white;
    padding: 1rem;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .scroll-btn {
    width: 40px;
    height: 60px;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  
  .scroll-left {
    margin-right: 10px;
  }
  
  .scroll-right {
    margin-left: 10px;
  }
  @media screen and (max-width: 500px) {
    .circle-image-cat {
      width: 130px;
      height: 130px;
      object-fit: cover;
      border-radius: 50%; /* ✅ makes it a circle */
      border: 3px solid #444;
    
      display: block;
      margin: 0 auto; /* 💡 centers the image horizontally */
  }
  .scroll-item {
    min-width: 180px;
    background: #eee;
    padding: 1rem;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .scroll-item1 {
    min-width: 180px;
    background: white;
    padding: 1rem;
    border-radius: 8px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .circle-image {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 50%; /* ✅ makes it a circle */
    border: 3px solid #444;
  }
  }`, "",{"version":3,"sources":["webpack://./src/components/style/ScrollGallery.css"],"names":[],"mappings":";;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB,EAAE,wBAAwB;IAC5C,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB,EAAE,wBAAwB;IAC5C,sBAAsB;IACtB,YAAY;EACd;EACA;IACE;MACE,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,kBAAkB,EAAE,wBAAwB;MAC5C,sBAAsB;MACtB,YAAY;IACd;EACF;;;;EAIA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE;MACE,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,kBAAkB,EAAE,wBAAwB;MAC5C,sBAAsB;;MAEtB,cAAc;MACd,cAAc,EAAE,sCAAsC;EAC1D;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB,EAAE,wBAAwB;IAC5C,sBAAsB;EACxB;EACA","sourcesContent":["\n  \n  .circle-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0.5rem 0;\n  }\n  \n  .circle-image {\n    width: 150px;\n    height: 150px;\n    object-fit: cover;\n    border-radius: 50%; /* ✅ makes it a circle */\n    border: 3px solid #444;\n  }\n  \n  .item-title {\n    margin-top: 0.5rem;\n    font-size: 1rem;\n    font-weight: 500;\n    text-align: center;\n  }\n  \n  .circle-image-cat {\n    width: 200px;\n    height: 200px;\n    object-fit: cover;\n    border-radius: 50%; /* ✅ makes it a circle */\n    border: 3px solid #444;\n    margin: auto;\n  }\n  @media screen and (min-width: 850px) and (max-width: 850px) {\n    .circle-image-cat {\n      width: 150px;\n      height: 150px;\n      object-fit: cover;\n      border-radius: 50%; /* ✅ makes it a circle */\n      border: 3px solid #444;\n      margin: auto;\n    }\n  }\n \n\n\n  .scroll-wrapper {\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .scroll-content {\n    width: 100%;\n    display: flex;\n    gap: 1rem;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    padding: 1rem;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  \n  .scroll-content::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .scroll-item {\n    min-width: 250px;\n    background: #eee;\n    padding: 1rem;\n    border-radius: 8px;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n  .scroll-item1 {\n    min-width: 250px;\n    background: white;\n    padding: 1rem;\n    border-radius: 8px;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n  .scroll-btn {\n    width: 40px;\n    height: 60px;\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    font-size: 1.5rem;\n    cursor: pointer;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n  }\n  \n  .scroll-left {\n    margin-right: 10px;\n  }\n  \n  .scroll-right {\n    margin-left: 10px;\n  }\n  @media screen and (max-width: 500px) {\n    .circle-image-cat {\n      width: 130px;\n      height: 130px;\n      object-fit: cover;\n      border-radius: 50%; /* ✅ makes it a circle */\n      border: 3px solid #444;\n    \n      display: block;\n      margin: 0 auto; /* 💡 centers the image horizontally */\n  }\n  .scroll-item {\n    min-width: 180px;\n    background: #eee;\n    padding: 1rem;\n    border-radius: 8px;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n  .scroll-item1 {\n    min-width: 180px;\n    background: white;\n    padding: 1rem;\n    border-radius: 8px;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n  .circle-image {\n    width: 100px;\n    height: 100px;\n    object-fit: cover;\n    border-radius: 50%; /* ✅ makes it a circle */\n    border: 3px solid #444;\n  }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
